(() => {
  if (window.FoSearch) { window.FoSearch.initialize(); return; }
  const bound = new Map();
  const initialize = () => {
    for (const [dialog, cleanup] of bound) if (!dialog.isConnected) { cleanup(); bound.delete(dialog); }
    document.querySelectorAll('[data-fo-search-dialog]').forEach(dialog => {
      if (bound.has(dialog)) return;
      const root = dialog.closest('.fh-header'), headerForm = root?.querySelector('.fo-header-search');
      const opener = headerForm?.querySelector('[data-fo-search-open]'), icon = headerForm?.querySelector('[data-fo-search-trigger]');
      const input = dialog.querySelector('[data-fo-search-input]'), defaults = dialog.querySelector('[data-fo-search-default]');
      const results = dialog.querySelector('[data-fo-search-results]'), status = dialog.querySelector('[data-fo-search-status]');
      const all = dialog.querySelector('[data-fo-search-all]'), allQuery = dialog.querySelector('[data-fo-search-all-query]'), clear = dialog.querySelector('[data-fo-search-clear]');
      if (!headerForm || !opener || !input || !defaults || !results || !status || !all || !allQuery || typeof dialog.showModal !== 'function') return;
      const lifetime = new AbortController();
      const listen = (target, event, handler) => target?.addEventListener(event, handler, { signal: lifetime.signal });
      const mobile = window.matchMedia('(max-width:699px)'), desktopPlaceholder = opener.placeholder;
      const syncPlaceholder = () => { opener.placeholder = input.placeholder = mobile.matches ? dialog.dataset.mobilePlaceholder : desktopPlaceholder; };
      const syncViewport = () => {
        dialog.style.setProperty('--fo-search-viewport', Math.round(window.visualViewport?.height || window.innerHeight) + 'px');
        dialog.style.setProperty('--fo-search-top', Math.round(window.visualViewport?.offsetTop || 0) + 'px');
      };
      syncPlaceholder(); listen(mobile, 'change', syncPlaceholder);
      listen(window.visualViewport, 'resize', syncViewport); listen(window.visualViewport, 'scroll', syncViewport);
      const terms = [...dialog.querySelectorAll('.fo-search-suggestions__terms [data-fo-search-term]')].map(button => button.dataset.foSearchTerm);
      const cache = new Map();
      let controller, timer, version = 0, returnFocus, suppressOpen = false, focusTimer;
      const cancel = () => { clearTimeout(timer); controller?.abort(); version++; };
      const setExpanded = value => { opener.setAttribute('aria-expanded', value); icon?.setAttribute('aria-expanded', value); };
      const countMessage = count => (count === 1 ? dialog.dataset.countOne : dialog.dataset.countOther).replace('[count]', String(count));
      const node = (tag, className, text) => { const element = document.createElement(tag); element.className = className; if (text !== undefined) element.textContent = text; return element; };
      const renderLocal = query => {
        const tools = window.FoShopTools;
        if (!tools?.products.length || tools.products.length >= 250) return false;
        const picks = tools.search(query), grid = node('div', 'fo-search-grid');
        const money = amount => new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: dialog.dataset.currency || 'EUR' }).format(amount / 100);
        const matches = terms.filter(term => tools.query(term).includes(tools.query(query))).slice(0, 4);
        results.replaceChildren();
        if (matches.length) {
          const suggestions = node('div', 'fo-search-query-links');
          matches.forEach(term => { const button = node('button', '', term); button.type = 'button'; button.dataset.foSearchTerm = term; suggestions.append(button); });
          results.append(suggestions);
        }
        picks.slice(0, 6).forEach(product => {
          const template = [...document.querySelectorAll('template[data-fo-shop-card]')].find(template => template.dataset.foShopCard === product.handle);
          const source = template?.content, originalLink = source?.querySelector('.fo-card-image');
          const variants = product.variants.filter(variant => variant.available && variant.price > 0);
          const variant = variants.reduce((best, item) => item.price < best.price ? item : best, variants[0]);
          if (!originalLink || !variant) return;
          const card = node('a', 'fo-search-card'); card.href = originalLink.getAttribute('href');
          const media = node('span', 'fo-search-card__media'), image = source.querySelector('img')?.cloneNode(true);
          if (image) { image.sizes = '(max-width:699px) 42vw,20vw'; image.loading = 'lazy'; media.append(image); }
          const sale = variant.compare > variant.price;
          if (sale) media.append(node('span', 'fo-search-card__discount', '−' + Math.round((variant.compare - variant.price) * 100 / variant.compare) + ' %'));
          const price = node('span', 'fo-search-card__price' + (sale ? ' fo-search-card__price--sale' : ''));
          const varies = variants.some(item => item.price !== variant.price);
          price.append(document.createTextNode((varies ? dialog.dataset.priceFrom + ' ' : '') + money(variant.price)));
          if (sale) price.append(node('s', '', money(variant.compare)));
          card.append(media, node('span', 'fo-search-card__vendor', product.vendor), node('span', 'fo-search-card__title', product.title), price); grid.append(card);
        });
        if (grid.children.length) results.append(node('h2', '', dialog.dataset.resultsLabel), grid);
        results.hidden = !grid.children.length && !matches.length;
        defaults.hidden = Boolean(grid.children.length); results.removeAttribute('aria-busy');
        status.textContent = picks.length ? countMessage(picks.length) : dialog.dataset.empty;
        return true;
      };
      const fetchResults = async (query, requestVersion) => {
        if (requestVersion !== version || !dialog.open) return;
        try {
          if (renderLocal(query)) return;
          let html = cache.get(query);
          if (!html) {
            const url = new URL(dialog.dataset.endpoint, location.origin);
            url.searchParams.set('q', query); url.searchParams.set('section_id', 'fo-predictive-search');
            url.searchParams.set('resources[type]', 'product,query'); url.searchParams.set('resources[limit]', '6');
            url.searchParams.set('resources[options][unavailable_products]', 'hide');
            if (dialog.dataset.previewTheme) url.searchParams.set('preview_theme_id', dialog.dataset.previewTheme);
            controller = new AbortController();
            const response = await fetch(url, { signal: controller.signal, headers: { Accept: 'text/html' } });
            if (!response.ok) throw Error('Search response failed');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html'), content = doc.querySelector('[data-fo-predictive-response]');
            if (!content) throw Error('Search response missing');
            html = content.outerHTML;
            if (cache.size >= 20) cache.delete(cache.keys().next().value);
            cache.set(query, html);
          }
          if (requestVersion !== version || !dialog.open || input.value.trim() !== query) return;
          results.innerHTML = html;
          const count = Number(results.querySelector('[data-fo-predictive-response]').dataset.count) || 0;
          results.hidden = false; defaults.hidden = count > 0; results.removeAttribute('aria-busy');
          status.textContent = count ? countMessage(count) : dialog.dataset.empty;
        } catch (error) {
          if (error.name === 'AbortError' || requestVersion !== version || !dialog.open) return;
          results.hidden = true; defaults.hidden = false; results.removeAttribute('aria-busy'); status.textContent = dialog.dataset.failed;
        }
      };
      const update = (immediate = false) => {
        cancel(); const query = input.value.trim();
        dialog.toggleAttribute('data-has-query', Boolean(query)); if (clear) clear.hidden = !input.value;
        opener.value = input.value; allQuery.value = query; defaults.hidden = Boolean(query); results.hidden = true; all.hidden = !query;
        status.textContent = query ? dialog.dataset.loading : ''; results.setAttribute('aria-busy', String(Boolean(query)));
        if (!query) return;
        const requestVersion = version; timer = setTimeout(() => fetchResults(query, requestVersion), immediate ? 0 : 180);
      };
      const open = origin => {
        if (suppressOpen) return;
        if (dialog.open) { input.focus(); return; }
        returnFocus = origin || opener; root.querySelector('.fh-mobile-nav')?.removeAttribute('open'); input.value = opener.value;
        syncViewport(); dialog.showModal(); setExpanded('true'); input.focus(); update();
      };
      const close = () => { suppressOpen = true; dialog.close(); };
      listen(opener, 'focus', () => open(opener)); listen(opener, 'click', () => open(opener));
      listen(headerForm, 'submit', event => { event.preventDefault(); open(event.submitter || opener); });
      listen(input, 'input', () => update()); listen(clear, 'click', () => { input.value = ''; input.focus(); update(); });
      listen(dialog, 'keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); close(); return; }
        if (event.key === 'ArrowDown' && event.target === input) {
          const first = (results.hidden ? defaults : results).querySelector('a,button'); if (first) { event.preventDefault(); first.focus(); }
        }
        if (event.key === 'ArrowUp' && event.target !== input && event.target.closest('[data-fo-search-results],[data-fo-search-default]')) { event.preventDefault(); input.focus(); }
      });
      listen(dialog, 'cancel', () => { suppressOpen = true; });
      listen(dialog, 'click', event => {
        const term = event.target.closest('[data-fo-search-term]');
        if (term) { event.preventDefault(); input.value = term.dataset.foSearchTerm; input.focus(); update(true); }
        if (event.target.closest('[data-fo-search-close]')) close();
        if (event.target === dialog) { const box = dialog.getBoundingClientRect(); if (event.clientY < box.top || event.clientY > box.bottom || event.clientX < box.left || event.clientX > box.right) close(); }
      });
      listen(dialog, 'submit', event => { input.value = input.value.trim(); allQuery.value = input.value; if (!input.value) { event.preventDefault(); input.focus(); } });
      listen(dialog, 'close', () => {
        cancel(); results.removeAttribute('aria-busy'); setExpanded('false'); suppressOpen = true;
        if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
        focusTimer = setTimeout(() => { suppressOpen = false; }, 0);
      });
      bound.set(dialog, () => { cancel(); clearTimeout(focusTimer); lifetime.abort(); if (dialog.open) dialog.close(); });
    });
  };
  window.FoSearch = { initialize };
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', event => { for (const [dialog, cleanup] of bound) if (event.target.contains(dialog)) { cleanup(); bound.delete(dialog); } });
  initialize();
})();
